// removed by extract-text-webpack-plugin
module.exports = {"Landing":"Landing__Landing__2bQPc","Citation":"Landing__Citation__U3x_L","Button":"Landing__Button__9cyW3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Landing/Landing.css
// module id = 105
// module chunks = 0